import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const MobilePhone = forwardRef<SVGSVGElement, SvgIconProps>(
  function MobilePhone(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path
          d="m7.89,3l8.16,0c0.78,0 1.45,0.62 1.45,1.36l0,15.28c0,0.74 -0.67,1.36 -1.45,1.36l-8.16,0c-0.79,0 -1.39,-0.62 -1.39,-1.36l0,-15.28c0,-0.74 0.6,-1.36 1.39,-1.36zm-0.36,2.67l8.94,0l0,11.75l-8.94,0l0,-11.75zm4.47,12.5c0.67,0 1.21,0.5 1.21,1.13c0,0.62 -0.54,1.13 -1.21,1.13c-0.66,0 -1.2,-0.5 -1.2,-1.13c0,-0.63 0.54,-1.14 1.2,-1.14l0,0.01zm-1.51,-14.03l2.96,0c0.55,0 0.55,0.68 0,0.68l-2.95,0c-0.48,0 -0.48,-0.68 0,-0.68l-0.01,0z"
          fillRule="evenodd"
        />
      </SvgIcon>
    )
  },
)

export default MobilePhone
